/**
 * @highfive/types — shared FE/BE contracts (audit finding #13).
 *
 * Single source of truth for the values and shapes that MUST agree across the
 * frontend and backend. Consumed as a workspace package by both `backend` and
 * `frontend/web`.
 *
 * Scope note: only cross-boundary invariants live here. Types that legitimately
 * differ between FE and BE at the serialization boundary (e.g. timestamp fields
 * are `Date` inside the backend and `string` on the wire, and `AuthTokens`
 * intentionally omits `refreshToken` on the client per audit #17) are NOT forced
 * into one shape — that would be incorrect, not DRY. What belongs here are the
 * things whose divergence is always a bug: shared limits, role unions, and DTOs
 * that are byte-identical on both sides.
 */
// ── Shared limits/constants ───────────────────────────────────────────────
/**
 * Maximum message body length, enforced identically on the client (input cap +
 * counter) and the server (Zod validator). Previously drifted: client 5000 vs
 * server 10000 (audit finding #9).
 */
export const MESSAGE_MAX_LENGTH = 10000;
/** Roles that may perform administrative actions (mirrors backend roles.util ADMIN_ROLES). */
export const ADMIN_ROLES = ['admin', 'super_admin'];
